<template>
  <div>
    <ScrollupSection />
    <div class="main overflow-hidden">
      <HeaderSection />
      <PolicyContents />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../../Scrollup/Scrollup'
import HeaderSection from '../../Header/HeaderOne'
import PolicyContents from '../../PolicyContents/PolicyContents'

export default {
  name: 'Policy',
  components: {
    ScrollupSection,
    HeaderSection,
    PolicyContents
  }
}
</script>

<style>

</style>